import React from 'react';
import CheckboxGroup from './CheckboxGroup';
import {
  useCreateClientAccountScoreSettingCustomizeItemSelectOptionMutation,
  useDestroyClientAccountScoreSettingCustomizeItemSelectOptionMutation,
  ClientPreleadCustomizeItemSelectOption,
} from 'api';
import {CustomizeItemContext} from '../../../CustomizeItemContext';

interface Props {
  priority: number;
}

export default ({priority}: Props) => {
  const [create] = useCreateClientAccountScoreSettingCustomizeItemSelectOptionMutation({});
  const [destroy] = useDestroyClientAccountScoreSettingCustomizeItemSelectOptionMutation({});
  
  const {
    id,
    clientPreleadCustomizeItem,
    selectOptionsGroupByPriority,
    clientAccountScoreSettingCustomizeItemSelectOptions,
  } = React.useContext(CustomizeItemContext);

  const options = [
    ...clientPreleadCustomizeItem?.selectOptions?.map(
      (option: ClientPreleadCustomizeItemSelectOption) => ({
        text: option.label,
        value: option.id,
        keyword: option.label,
      }),
    ) || [],
  ];

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {checked, value} = e.target;
    const variables = {
      priority,
      accountScoreSettingCustomizeItemId: id,
      clientPreleadCustomizeItemSelectOptionId: value,
    };
    
    if (checked) {
      create({
        variables,
      });
    } else {
      destroy({
        variables,
      });
    }
  };

  const currentSelectedValues = clientAccountScoreSettingCustomizeItemSelectOptions
    ?.filter((option) => option.priority === priority)
    ?.map((option) => option.clientPreleadCustomizeItemSelectOption?.id)
    ?? [];

  return (
    <CheckboxGroup
      filter
      options={options}
      values={currentSelectedValues}
      allSelected={clientAccountScoreSettingCustomizeItemSelectOptions?.map(
        (option) => option.clientPreleadCustomizeItemSelectOption?.id,
      ) ?? []}
      onChange={handleChange}
    />
  );
};